const MODELS = [
  { id: 'byt-gpt-5.5', name: 'GPT-5.5', vendor: 'OpenAI', status: '可用' },
  { id: 'byt-gpt-5.4', name: 'GPT-5.4', vendor: 'OpenAI', status: '可用' },
  { id: 'byt-claude-opus-4-7', name: 'Claude Opus 4.7', vendor: 'Anthropic', status: '可用' },
  { id: 'byt-claude-opus-4-6', name: 'Claude Opus 4 6', vendor: 'Anthropic', status: '可用' },
  { id: 'byt-gemini-3.1-pro', name: 'Gemini 3.1 Pro', vendor: 'Google', status: '可用' },
  { id: 'byt-gemini-3', name: 'Gemini 3', vendor: 'Google', status: '可用' },
];

const Models = () => (
  <>
    <p className="console-panel-desc">浏览当前账户可用的 AI 模型列表。</p>
    <div className="console-card">
      <div className="console-card-body console-table-wrap">
        <table className="console-table">
          <thead>
            <tr>
              <th>模型 ID</th>
              <th>名称</th>
              <th>供应商</th>
              <th>状态</th>
            </tr>
          </thead>
          <tbody>
            {MODELS.map((model) => (
              <tr key={model.id}>
                <td>
                  <code style={{ fontSize: '0.8125rem', color: 'var(--accent)' }}>{model.id}</code>
                </td>
                <td>{model.name}</td>
                <td>{model.vendor}</td>
                <td>
                  <span className="console-tag success">{model.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>
);

export default Models;
